<template>
  <v-card height="100%" v-once>
    <v-card-title primary-title>
      <div class="headline">{{labels.shipment}}</div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.convy}}</v-subheader>
            <div>{{cargoForm.convy}} - {{query.convy}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.lcNo}}</v-subheader>
            <div v-if="cargoForm.lcNo !== null">{{cargoForm.lcNo}}</div>
            <div v-else> - </div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.vesNo}}</v-subheader>
            <div>{{cargoForm.vesNo}} - {{query.vesName}}</div>
            <div v-if="cargoForm.vesNo !== null" class="grey--text caption">(GRT/NRT {{query.grt}}/{{query.nrt}})</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.voyNo}}</v-subheader>
            <div>{{cargoForm.voyNo}} - {{query.voyDet}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.voyDateType}}</v-subheader>
            <div>{{cargoForm.voyDateType}} - {{query.voyDateType}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.voyDate}}</v-subheader>
            <div v-if="cargoForm.voyDate">{{formatDisplayDate(cargoForm.voyDate)}}</div>
            <div v-else> - </div>
          </v-flex>
          <v-flex xs12>
            <v-subheader class="queryLabel">{{labels.voyArea}}</v-subheader>
            <div>{{cargoForm.voyArea}} - {{query.voyArea}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.portFrom}}</v-subheader>
            <div>{{cargoForm.portFrom}} - {{query.portFrom}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.portTo}}</v-subheader>
            <div>{{cargoForm.portTo}} - {{query.portTo}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.voyDesc}}</v-subheader>
            <div v-if="cargoForm.voyDesc !== null">{{cargoForm.voyDesc}}</div>
            <div v-else> - </div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.surveyAgt}}</v-subheader>
            <div>{{cargoForm.surveyAgt}} - {{query.surveyAgt}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.settlingAgt}}</v-subheader>
            <div>{{cargoForm.settlingAgt}} - {{query.settlingAgt}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.clmPayAt}}</v-subheader>
            <div v-if="cargoForm.clmPayAt !== null">{{cargoForm.clmPayAt}}</div>
            <div v-else> - </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-title>
      <div class="body-2">{{labels.consignee}}</div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.csgnName}}</v-subheader>
            <div v-if="cargoForm.csgnName">{{cargoForm.csgnName}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs12>
            <v-subheader class="queryLabel">{{labels.csgnAdd1}}</v-subheader>
            <div v-if="cargoForm.csgnAdd1">{{cargoForm.csgnAdd1}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs12>
            <v-subheader class="queryLabel">{{labels.csgnAdd2}}</v-subheader>
            <div v-if="cargoForm.csgnAdd2">{{cargoForm.csgnAdd2}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs12>
            <v-subheader class="queryLabel">{{labels.csgnAdd3}}</v-subheader>
            <div v-if="cargoForm.csgnAdd3">{{cargoForm.csgnAdd3}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs12>
            <v-subheader class="queryLabel">{{labels.csgnAdd4}}</v-subheader>
            <div v-if="cargoForm.csgnAdd4">{{cargoForm.csgnAdd4}}</div>
            <div v-else>-</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatDisplayDate } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'
export default {
  data() {
    return {
      labels: {
        shipment: 'Shipment',
        consignee: 'Consignee',
        convy: 'Conveyance',
        lcNo: 'Letter of Credit No.',
        vesNo: 'Vessel No.',
        vesselTonnages: 'GRT/NRT',
        voyNo: 'Voyage No.',
        voyDateType: 'Voyage Date Type',
        voyDate: 'Voyage Date',
        voyArea: 'Voyage Area',
        portFrom: 'Voyage From',
        portTo: 'Voyage To',
        voyDesc: 'Voyage Description',
        surveyAgt: 'Survey Agent',
        settlingAgt: 'Settling Agent',
        clmPayAt: 'Claims Payable At',
        csgnName: 'Name',
        csgnAdd1: 'Address Line 1',
        csgnAdd2: 'Address Line 2',
        csgnAdd3: 'Address Line 3',
        csgnAdd4: 'Address Line 4'
      }
    }
  },
  computed: {
    commonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    cargoForm() {
      return this.$store.state.agency.quotation.cargoForm
    },
    query() {
      return this.$store.state.agency.quotation.queryInfo
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    }
  }
}
</script>

<style lang="scss">

</style>
